import React from 'react';
import pt from 'prop-types';

import { Button, Stack } from '@metarouter-private/mr-mui';

export default function CommitMessageModalActions({ onCancel, onSave, loading }) {
  return (
    <Stack direction="row" spacing={1}>
      <Button variant="outlined" onClick={onCancel} disabled={loading}>
        Cancel
      </Button>
      <Button variant="contained" onClick={onSave} disabled={loading} data-test-id="saveRevisionButton">
        Save Revision
      </Button>
    </Stack>
  );
}

CommitMessageModalActions.propTypes = {
  onCancel: pt.func.isRequired,
  onSave: pt.func.isRequired,
  loading: pt.bool,
};
